import { render } from "./NotFound.vue?vue&type=template&id=241ec9cc"
const script = {}
script.render = render

export default script